var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widM pf23-inFo-safe-wrap pf23-lineBtm" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("p", { staticClass: "fntP padTSM" }, [
      _vm._v(
        "‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)"
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "clearfix marTSM" },
      [
        _vm._l(_vm.mainResponses, function(participant, idx) {
          return [
            _c(
              "div",
              {
                key: "participant-safe-" + idx,
                class: { "floL pcOnly": idx == 0, floR: idx != 0 }
              },
              [
                _c("div", { staticClass: "pf23-inFo-safe" }, [
                  _c(
                    "div",
                    {
                      staticClass: "amway-theme",
                      staticStyle: { width: "55%" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                        },
                        [
                          _c(
                            "label",
                            { staticClass: "amw-radio-wrap radio-label focus" },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: {
                                  type: "radio",
                                  id: "Q040-" + idx,
                                  name: "safety-radio-" + idx,
                                  value: "Y",
                                  disabled:
                                    !participant.attendance_yn ||
                                    participant.attendance_yn === "N" ||
                                    !_vm.infoAvailable
                                },
                                domProps: {
                                  checked:
                                    participant.questions["Q040"].raw_data ===
                                    "Y"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.inputRadioAnswer(
                                      "" + idx,
                                      "Q040",
                                      "Y"
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "amw-radio-overlay" }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "amw-label-radio-text" },
                                [_vm._v("예")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticClass: "amw-radio-wrap radio-label focus" },
                            [
                              _c("input", {
                                staticClass: "amw-global-radio",
                                attrs: {
                                  type: "radio",
                                  name: "safety-radio-" + idx,
                                  value: "N",
                                  disabled:
                                    !participant.attendance_yn ||
                                    participant.attendance_yn === "N" ||
                                    !_vm.infoAvailable
                                },
                                domProps: {
                                  checked:
                                    participant.questions["Q040"].raw_data ===
                                    "N"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.inputRadioAnswer(
                                      "" + idx,
                                      "Q040",
                                      "N"
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "amw-radio-overlay" }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "amw-label-radio-text" },
                                [_vm._v("아니오")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            )
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        staticClass: "marTS fntE",
        staticStyle: {
          color: "#d91734",
          "text-indent": "-0.6em",
          "padding-left": "0.6em"
        }
      },
      [
        _vm._v(
          "* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에 작성하여 주시기 바랍니다."
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP padTSM" }, [
      _vm._v("안전 확인 "),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ae931e8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ae931e8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/singapore/components/SurveyParticipantSafe.vue
// module id = null
// module chunks = 